import React from 'react';
import PropTypes from 'prop-types';

import ConfidenceIcon0 from '../../assets/icons/alert-confidences/0-20.svg';
import ConfidenceIcon20 from '../../assets/icons/alert-confidences/20-40.svg';
import ConfidenceIcon40 from '../../assets/icons/alert-confidences/40-60.svg';
import ConfidenceIcon60 from '../../assets/icons/alert-confidences/60-80.svg';
import ConfidenceIcon80 from '../../assets/icons/alert-confidences/80-100.svg';

import * as S from './styled';

const ConfidenceTag = ({ value = 0 }) => {
  const confidenceIconMap = {
    0: <ConfidenceIcon0 />,
    20: <ConfidenceIcon20 />,
    40: <ConfidenceIcon40 />,
    60: <ConfidenceIcon60 />,
    80: <ConfidenceIcon80 />
  };

  const getConfidenceIcon = () => {
    if (value === 100) {
      return <ConfidenceIcon80 style={{ position: 'relative', left: '1px' }} />;
    }
    const range = Math.floor(value / 20) * 20;
    return confidenceIconMap[range] || <ConfidenceIcon0 />;
  };

  const confidenceIcon = getConfidenceIcon();

  return (
    <S.Wrapper>
      <S.Title>{value}</S.Title>
      {confidenceIcon}
    </S.Wrapper>
  );
};

ConfidenceTag.propTypes = {
  value: PropTypes.number
};

export default ConfidenceTag;
